import React from "react";
import "./index.css";
import { QRCodeCanvas } from "qrcode.react";
import IconTearDropButton from "../../_utils/CommonButtons/IconTearDropButton";
import { IntervalConfiguration } from "../../../utils/configurationProvider";
import SVGComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons";

const TotpBackupCodes = ({
  backupCodes,
  open,
  setOpen,
  setTooltipText,
  tooltipText,
  openAccordion,
  setOpenAccordion,
  hashKey,
  openScannerCode,
  setOpenScannerCode,
  tooltiphashText,
  setTooltiphashText,
}) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(backupCodes)
      .then(() => {
        setTooltipText("Copied!");
        setOpen(true);

        setTimeout(() => {
          setOpen(false);
          setTooltipText("Click to copy");
        }, IntervalConfiguration.intervalExtraLarge);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleCopyHash = (e) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(hashKey?.key)
      .then(() => {
        setTooltiphashText("Copied!");
        setOpenScannerCode(true);

        setTimeout(() => {
          setOpenScannerCode(false);
          setTooltiphashText("Click to copy");
        }, IntervalConfiguration.intervalExtraLarge);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div className="totp-top-main Qlg:justify-between">
      <div className="divide-totp">
        <div className="totp_backup_codes_left">
          <h4 className="totp_backup_codes_left_1">
            Download & Save Backup Codes
          </h4>
          <p className="totp_backup_codes_left_2">
            Backup codes allow to log in to your account if you're unable to
            receive TOTP codes from your authenticator app.{" "}
          </p>
          <div className="totp_backup_codes_left_3">
            <div className="w-full flex flex-row justify-end absolute">
              <IconTearDropButton
                btnType="button"
                enabledBgColor="var(--primary-nav-act)"
                hoverOption="white"
                icon={ICONS?.COPY}
                title={tooltipText}
                handleFunction={handleCopy}
              />
            </div>
            <div className="totp_backup_codes_left_all_backup">
              {backupCodes?.map((val, i) => {
                return <div key={i}>{val}</div>;
              })}
            </div>
          </div>
          <p className="totp_backup_codes_left_4">
            Ensure you save the backup codes securely. Do not share your backup
            codes with anyone.
          </p>
        </div>

        <div
          className={`totp_acc ${openAccordion ? "" : "global-hover-white relative z-z-index-content cursor-pointer"}`}
          style={{
            height: openAccordion ? "fit-content" : "auto",
            overflow: "hidden",
          }}
          onClick={() => {
            setOpenAccordion(!openAccordion);
          }}
        >
          <div className="totp_acc_main">
            <SVGComponent
              url={ICONS?.ADD_BUTTON_WHITE}
              color="var(--text-primary)"
              height={"var(--icon-sm)"}
              width={"var(--icon-sm)"}
            />
            <h3 className="totp_acc_title">Want to add more devices ?</h3>

            <SVGComponent
              url={
                openAccordion ? ICONS?.ARROW_UP_WHITE : ICONS?.ARROW_DOWN_WHITE
              }
              color="var(--text-primary)"
              height={"var(--icon-sm)"}
              width={"var(--icon-sm)"}
            />
          </div>
          {openAccordion && (
            <div className="totp_acc_crane">
              <div className="totp-scanner-left-4">
                <p className="totp_register_more">
                  To register more devices, use the authenticator app on each
                  devices and scan the QR code shown below, or input the passkey
                  manually.
                </p>
                <div className="totp-scanner-left-4-qrcode">
                  <h4>Scan QR code on authenticator app</h4>
                  <div className="totp-scanner-left-4-qrcode-scanner-main">
                    <div className="totp-scanner-left-4-qrcode-scanner">
                      <QRCodeCanvas
                        value={`otpauth://totp/Xpentra:${hashKey?.email}?secret=${hashKey?.key}&issuer=Xpentra`}
                        size={90}
                      />
                    </div>
                  </div>
                </div>
                <h4>OR</h4>

                <div className="flex flex-col w-full justify-between bg-primary-nav gap-gap-sm py-padding-sm px-padding-md rounded-border-radius-md relative">
                  <p className="text-font-xs font-semibold text-text-secondary">
                    Copy passkey
                  </p>
                  <div className="flex w-full justify-between bg-primary-nav">
                    <div className="top-top-base right-right-base absolute">
                      <IconTearDropButton
                        btnType="button"
                        handleFunction={handleCopyHash}
                        isDisabled={false}
                        isLoading={false}
                        title={tooltipText}
                        enabledBgColor={"var(--primary-nav-act)"}
                        icon={ICONS?.COPY}
                        hoverOption="white"
                      />
                    </div>

                    <p className="text-font-xs text-text-primary font-semibold">
                      {hashKey?.key}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="divide-totp">
        <div className="totp_backup_codes_right">
          <div className="totp_backup_codes_right_top">
            <img
              src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
              alt="Warning"
            />
            <p>
              If you use a backup code to log in, your TOTP setup will be
              disabled, and you'll have to set it up again.
            </p>
          </div>
          <div className="totp_backup_codes_right_bottom flex flex-col">
            <div className="flex justify-center items-center">
              <SVGComponent
                url={ICONS?.BACKUP_CODES}
                height={"var(--graphic-square-height-md)"}
                width={"var(--graphic-width-md)"}
              />
            </div>

            <p className="text-text-primary font-sans font-normal text-font-xs mt-margin-sm">
              To complete the process, click “Download”
            </p>
          </div>
        </div>
      </div>

      <div className="totp_backup_codes_bottom_top">
        <img
          src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
          alt="Warning"
        />
        <p>
          If you use a backup code to log in, your TOTP setup will be disabled,
          and you'll have to set it up again.
        </p>
      </div>
    </div>
  );
};

export default TotpBackupCodes;
